import { cva } from 'class-variance-authority'

/**
 * Dialog Content variants
 */
export const dialogContentVariants = cva(
  'fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded'
)

export const dialogOverlayVariants = cva(
  'fixed inset-0 z-50 bg-black/80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0'
)

export const dialogHeaderVariants = cva(
  'flex flex-col space-y-1.5 text-center sm:text-left'
)

export const dialogTitleVariants = cva(
  'text-lg font-semibold leading-none tracking-tight'
)

export const dialogDescriptionVariants = cva(
  'text-sm text-muted-foreground'
)

/** Close button in the top-right corner of DialogContent */
export const dialogCloseVariants = cva(
  'rounded opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:ring-ring data-[state=open]:bg-accent data-[state=open]:text-muted-foreground'
)
